<template>
  <div>
    <div class="Top_Total">
      <div class="Top_TotalR">
        <img src="../assets/img/11.svg" alt="">
        <div class="Top_TotalRbox">
          <div class="Top_title">今日收款金额统计</div>
          <div class="Top_TotalLLi">{{drawprice.sale_now_price}}</div>
        </div>
      </div>
      <div class="Top_TotalR">
        <img src="../assets/img/22.svg" alt="">
        <div class="Top_TotalRbox">
        <div class="Top_title">今日销售单数统计</div>
          <div class="Top_TotalRLi">{{drawprice.sale_now_count}}</div>
        </div>
      </div>
      <div class="Top_TotalR">
        <img src="../assets/img/33.svg" alt="">
        <div class="Top_TotalRbox">
        <div class="Top_title">今日付款金额统计</div>
          <div class="Top_TotalRLi">{{drawprice.purchase_now_price}}</div>
        </div>
      </div>
      <div class="Top_TotalR">
        <img src="../assets/img/44.svg" alt="">
        <div class="Top_TotalRbox">
        <div class="Top_title">今日采购单数统计</div>
          <div class="Top_TotalRLi">{{drawprice.purchase_now_count}}</div>
        </div>
      </div>
      <div class="Top_TotalR">
        <img src="../assets/img/55.svg" alt="">
        <div class="Top_TotalRbox">
        <div class="Top_title">累计应收款</div>
          <div class="Top_TotalRLi">{{drawprice.sale_price}}</div>
        </div>
      </div>
      <div class="Top_TotalR">
        <img src="../assets/img/66.svg" alt="">
        <div class="Top_TotalRbox">
        <div class="Top_title">累计应付款</div>
          <div class="Top_TotalRLi">{{drawprice.purchase_price}}</div>
        </div>
      </div>
    </div>
    <div class="Top_date">
      <div class="Top_title">搜索条件</div>
      <div class="Top_conter">
        <el-select v-model="Rangedate" placeholder="请选择时间范围" @change="RangedateChange" clearable>
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-card style="margin-top: 20px;">
      <div class="title">{{radio1}}金额统计</div>
      <el-radio-group v-model="radio1" @change="selecttype">
        <el-radio-button label="付款"></el-radio-button>
        <el-radio-button label="收款"></el-radio-button>
      </el-radio-group>
      <div id="myChartdrawLine" :style="{width: '100%', height: '300px'}"></div>
    </el-card>

  </div>
</template>
<script>
export default {
  data() {
    return{
      drawprice:{
        purchase_count: 0,
        purchase_now_count: 0,
        purchase_now_price: 0,
        purchase_price: 0,
        sale_count: 0,
        sale_now_count: 0,
        sale_now_price: 0,
        sale_price: 0
      },
      options: [{
        value: '1',
        label: '今天'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '本月'
      }, {
        value: '4',
        label: '本季度'
      }, {
        value: '5',
        label: '本年'
      }],
      Rangedate:'1',
      query:{
        start_date:'',
        end_date:'',
        p_type:'1,4'
      },
      radio1:'付款',
    }
  },
  created() {
    this.gettoday()
    this.drawLine()
    this.get()
  },
  methods: {
    async get(){
      const { data : res } = await this.$http.get('statistics/getStatistics')
      if (res.code!=200)return  this.$message.error(res.msg)
      this.drawprice=res.data
    },
    selecttype(){
      // console.log(this.radio1)
      if (this.radio1=='付款'){
        this.query.p_type='1,4'
      }else{
        this.query.p_type='2,3'
      }
      this.drawLine()
    },
    //获取采购金额
    async drawLine(){
      const { data : res } = await this.$http.get('paymentcensus/getPriceCount',{params:this.query})
      if (res.code!=200)return  this.$message.error(res.msg)
      this.drawdata=res.data
      // this.drawprice=res.data.price
      console.log(this.drawdata)
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChartdrawLine'))
      // 绘制图表
      myChart.setOption({
        // title: { text: '在Vue中使用echarts' },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: this.drawdata.datearr
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.drawdata.dataarr,
          type: 'line'
        }]
      });
    },
    gettoday(){
      var myDate = new Date();
      this.query.start_date=myDate.getFullYear() +'-'+ (myDate.getMonth()+1) +'-'+ myDate.getDate()
      myDate.setTime(myDate.getTime()+24*60*60*1000);
      this.query.end_date = myDate.getFullYear()+"-" + (myDate.getMonth()+1) + "-" + myDate.getDate();
      this.query.xtype='hours'
    },
    formatDate (date) {
      var myYear = date.getFullYear();
      var myMonth = date.getMonth() + 1;
      var myDate = date.getDate();
      if(myMonth < 10) {
        myMonth = '0' + myMonth;
      }
      if(myDate < 10) {
        myDate = '0' + myDate;
      }
      return myYear + '-' + myMonth + '-' + myDate;
    },
    //选择时间范围
    RangedateChange(){
      this.customdate=''
      var myDate = new Date();
      var now_year = myDate.getFullYear();
      var now_month = myDate.getMonth();
      var now_date = myDate.getDate();
      var now_day = myDate.getDay();
      if(this.Rangedate==1){
        this.gettoday()
      }
      else if(this.Rangedate==2){
        var weekStart = new Date(now_year, now_month, now_date - now_day +1);
        var weekEnd = new Date(now_year, now_month, now_date + (7 - now_day)+1);
        this.query.start_date=this.formatDate(weekStart)
        this.query.end_date =this.formatDate(weekEnd)
        this.query.xtype='day'
        // return this.formatDate(weekEnd);
        // return this.formatDate(weekStart);
      }
      else if(this.Rangedate==3){
        var MonthStart = new Date(now_year, now_month, 1);
        // var MonthEnd = new Date((new Date(now_year, now_month + 1, 1)).getTime() - 1000 * 60 * 60* 24);
        var MonthEnd = new Date(now_year, now_month+1, 1);
        this.query.start_date = this.formatDate(MonthStart)
        this.query.end_date = this.formatDate(MonthEnd)
        this.query.xtype='weeks'
      }
      else if(this.Rangedate==4){
        var QuarterStartMonth;
        if (now_month < 3) {
          QuarterStartMonth = 0;
        }
        if (now_month > 2 && now_month < 6) {
          QuarterStartMonth = 3;
        }
        if (now_month > 5 && now_month < 9) {
          QuarterStartMonth = 6;
        }
        if (now_month > 8 && now_month < 11) {
          QuarterStartMonth = 9;
        }
        var QuarterStart = new Date(now_year, QuarterStartMonth, 1);
        var QuarterEnd = new Date((new Date(now_year, QuarterStartMonth + 3, 1)));
        // console.log(this.formatDate(QuarterStart),this.formatDate(QuarterEnd))
        this.query.start_date = this.formatDate(QuarterStart)
        this.query.end_date = this.formatDate(QuarterEnd)
        this.query.xtype='month'
      }
      else if(this.Rangedate==5){
        var YearStart = new Date(now_year, 0, 1);
        var YearEnd = new Date((new Date(now_year + 1, 0, 1)));
        console.log(this.formatDate(YearStart),this.formatDate(YearEnd))
        this.query.start_date = this.formatDate(YearStart)
        this.query.end_date = this.formatDate(YearEnd)
        this.query.xtype='month'
      }
      this.get()
      this.drawLine()

    }
  },
}
</script>
<style>
.Top_date{
  width: 100%;
//height: 100px;
  box-sizing: border-box;
  background: #ffffff;
  margin-bottom: 20px;
}
.Top_title{
  position: relative;
  height: 42px;
  line-height: 42px;
  padding: 0 15px;
  border-bottom: 1px solid #f6f6f6;
  color: #333;
  border-radius: 2px 2px 0 0;
  font-size: 14px;
}
.el-select{
  margin-right: 30px;
}
.Top_conter{
  display: flex;
  padding: 20px;
}
.title{
  width: 100%;
  font-size: 24px;
  text-align: center;
}
.Top_Total{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.Top_TotalL,.Top_TotalR{
  width: 33%;
  box-sizing: border-box;
  background: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Top_TotalL img,.Top_TotalR img{
  margin-right: 20px;
}
.Top_TotalRbox{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
}
.Top_TotalRLi,.Top_TotalLLi{
  font-size: 36px;
  color: #666;
  line-height: 36px;
  padding: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}
</style>
